// modules
import { get } from 'lodash'
import { handleActions } from 'redux-actions'

// actions
import {
  deletePatientData,
  setActivePatientEnrolledProgram,
  setDiagnosisList,
  setDiagnosisLoading,
  setFollowUpCall,
  setPatientDiagnosis,
  setPatientDiagnosisLoading,
  setPatientDiagnosisModalLoading,
  setPatientDiseaseModalLoading,
  setPatientDiseases,
  setPatientDiseasesLoading,
  setPatientMedicalDevices,
  setPatientOnHoldHistory,
  setPatientRpmBillableHistory
} from 'src/store/modules/actionCreators'
import {
  setIsEnrollmentsUpdated,
  setPatientEnrollments
} from 'src/store/modules/patient/program'

const initialState = {
  activeProgram: {
    startDate: '',
    primaryDisease: null,
    comorbidities: []
  },
  patientDiseases: [],
  followUpCall: {},
  patientDiseasesLoading: false,
  patientDiseaseModalLoading: false,
  patientMedicalDevices: [],
  diagnosisLoading: false,
  diagnosisList: [],
  patientDiagnosis: [],
  patientDiagnosisLoading: false,
  patientDiagnosisModalLoading: false,
  isEnrollmentUpdated: false,
  patientOnHoldHistory: [],
  patientEnrollments: []
}

export default handleActions(
  {
    [setPatientEnrollments](state, { payload: patientEnrollments }) {
      return {
        ...state,
        patientEnrollments
      }
    },

    [setIsEnrollmentsUpdated](state, { payload }) {
      return {
        ...state,
        isEnrollmentUpdated: payload
      }
    },

    [setActivePatientEnrolledProgram](state, { payload }) {
      let updateActiveProgram

      if (!payload) {
        updateActiveProgram = initialState.activeProgram
      } else {
        updateActiveProgram = { ...payload }
      }

      const updPatientEnrollments = get(state, ['patientEnrollments'], [])
      const enrolledSubPrograms = get(
        updPatientEnrollments,
        [0, 'enrolledSubPrograms'],
        []
      )

      const updatedPrograms = enrolledSubPrograms.map((program) => {
        if (updateActiveProgram.uuid === program.uuid) {
          return updateActiveProgram
        }

        return program
      })

      if (updPatientEnrollments.length) {
        updPatientEnrollments[0].enrolledSubPrograms = updatedPrograms
      }

      return {
        ...state,
        activeProgram: updateActiveProgram,
        patientEnrollments: updPatientEnrollments
      }
    },

    [setPatientDiseases](state, { payload: patientDiseases }) {
      return {
        ...state,
        patientDiseases
      }
    },

    [setPatientDiseasesLoading](state, { payload: patientDiseasesLoading }) {
      return {
        ...state,
        patientDiseasesLoading
      }
    },

    [setPatientDiseaseModalLoading](
      state,
      { payload: patientDiseaseModalLoading }
    ) {
      return {
        ...state,
        patientDiseaseModalLoading
      }
    },

    [setPatientDiagnosis](state, { payload: patientDiagnosis }) {
      return {
        ...state,
        patientDiagnosis
      }
    },

    [setPatientDiagnosisLoading](state, { payload: patientDiagnosisLoading }) {
      return {
        ...state,
        patientDiagnosisLoading
      }
    },

    [setPatientDiagnosisModalLoading](
      state,
      { payload: patientDiagnosisModalLoading }
    ) {
      return {
        ...state,
        patientDiagnosisModalLoading
      }
    },

    [setFollowUpCall](state, { payload: followUpCall }) {
      return {
        ...state,
        followUpCall
      }
    },

    [setPatientMedicalDevices](state, { payload: patientMedicalDevices }) {
      return {
        ...state,
        patientMedicalDevices
      }
    },

    [setDiagnosisList](state, { payload: diagnosisList }) {
      return {
        ...state,
        diagnosisList
      }
    },

    [setDiagnosisLoading](state, { payload: diagnosisLoading }) {
      return {
        ...state,
        diagnosisLoading
      }
    },

    [setPatientOnHoldHistory](state, { payload: patientOnHoldHistory }) {
      return {
        ...state,
        patientOnHoldHistory
      }
    },

    [setPatientRpmBillableHistory](
      state,
      { payload: patientRpmBillableHistory }
    ) {
      return {
        ...state,
        patientRpmBillableHistory
      }
    },

    [deletePatientData]() {
      return initialState
    }
  },
  initialState
)
